// import React from "react";

// import {
//   Card,
//   CardBody,
//   Content,
//   Stack,
//   StackItem
// } from "@patternfly/react-core";

// const ProjectInfoCard = ({
//   title = null,
//   description = null,
//   image = null,
//   children = null,
//   isGlass = true
// }) => {
//   return (
//     <Card isGlass={isGlass}>
//       <CardBody>
//         <Stack hasGutter>
//           {image?.src && (
//             <StackItem>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "center"
//                 }}
//               >
//                 <img
//                   src={image.src}
//                   alt={image.alt || ""}
//                   loading="lazy"
//                   style={{
//                     display: "block",
//                     width: "100%",
//                     maxWidth: image.maxWidth || "480px",
//                     height: "auto"
//                   }}
//                 />
//               </div>
//             </StackItem>
//           )}

//           {(title || description) && (
//             <StackItem>
//               <Content>
//                 {title && (
//                   <h2>
//                     {title}
//                   </h2>
//                 )}

//                 {description && (
//                   <p>
//                     {description}
//                   </p>
//                 )}
//               </Content>
//             </StackItem>
//           )}

//           {children && (
//             <StackItem>
//               {children}
//             </StackItem>
//           )}
//         </Stack>
//       </CardBody>
//     </Card>
//   );
// };

// export default ProjectInfoCard;
import React from "react";

import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  Stack,
  StackItem
} from "@patternfly/react-core";

const ProjectInfoCard = ({
  title = null,
  description = null,
  image = null,
  imagePosition = "top",
  children = null,
  isGlass = true
}) => {
  const imageContent = image?.src ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%"
      }}
    >
      <img
        src={image.src}
        alt={image.alt || ""}
        loading="lazy"
        style={{
          display: "block",
          width: "100%",
          maxWidth: image.maxWidth || "480px",
          height: "auto"
        }}
      />
    </div>
  ) : null;

  const textContent = (
    <Stack hasGutter>
      {(title || description) && (
        <StackItem>
          <Content>
            {title && (
              <h2>
                {title}
              </h2>
            )}

            {description && (
              <p>
                {description}
              </p>
            )}
          </Content>
        </StackItem>
      )}

      {children && (
        <StackItem>
          {children}
        </StackItem>
      )}
    </Stack>
  );

  return (
    <Card isGlass={isGlass}>
      <CardBody>
        {imageContent && imagePosition === "right" ? (
          <Grid
            hasGutter
            alignItems="alignItemsCenter"
          >
            <GridItem
              span={12}
              md={7}
            >
              {textContent}
            </GridItem>

            <GridItem
              span={12}
              md={5}
            >
              {imageContent}
            </GridItem>
          </Grid>
        ) : (
          <Stack hasGutter>
            {imageContent && (
              <StackItem>
                {imageContent}
              </StackItem>
            )}

            <StackItem>
              {textContent}
            </StackItem>
          </Stack>
        )}
      </CardBody>
    </Card>
  );
};

export default ProjectInfoCard;